var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburgerIcon = function SvgHamburgerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hamburger-icon_svg__a{fill:none;stroke:#202020;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hamburger-icon_svg__a",
    d: "M0 1h25M0 9h25M0 17h25"
  })));
};

export { SvgHamburgerIcon as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:none;stroke:%23202020;stroke-width:2px;%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(2175.5 -1809.5)'%3e%3cline class='a' x2='25' transform='translate(-2175.5 1810.5)'/%3e%3cline class='a' x2='25' transform='translate(-2175.5 1818.5)'/%3e%3cline class='a' x2='25' transform='translate(-2175.5 1826.5)'/%3e%3c/g%3e%3c/svg%3e";